function initMosaicHover() {
  document.querySelectorAll('.mosaic-overlay').forEach(el => el.remove());
  
  const mosaicCards = document.querySelectorAll('.mosaic-hover-card');
  
  mosaicCards.forEach((card) => {
    if (card.dataset.mosaicInitialized) return;
    card.dataset.mosaicInitialized = 'true';
    
    const mosaicImagesData = card.getAttribute('data-mosaic-images');
    if (!mosaicImagesData) return;
    
    const mosaicImages = mosaicImagesData.split('||');
    if (mosaicImages.length < 2) return;
    
    const firstImage = card.querySelector('img.media--first');
    if (!firstImage) return;
    
    // Preload all mosaic images
    mosaicImages.forEach(imgUrl => {
      const preloadImg = new Image();
      preloadImg.src = imgUrl;
    });
    
    let currentIndex = 0;
    let hoverInterval = null;
    
    card.addEventListener('mouseenter', function() {
      currentIndex = 0;
      card.classList.add('cycling');
      
      const cycleImage = () => {
        currentIndex = (currentIndex + 1) % mosaicImages.length;
        
        firstImage.style.opacity = '0.3';
        
        setTimeout(() => {
          firstImage.src = mosaicImages[currentIndex];
          firstImage.srcset = mosaicImages[currentIndex];
          firstImage.style.opacity = '1';
        }, 300);
      };
      
      cycleImage();
      hoverInterval = setInterval(cycleImage, 1500);
    });
    
    card.addEventListener('mouseleave', function() {
      if (hoverInterval) {
        clearInterval(hoverInterval);
        hoverInterval = null;
      }
      
      card.classList.remove('cycling');
      firstImage.style.opacity = '1';
      firstImage.src = mosaicImages[0];
      firstImage.srcset = mosaicImages[0];
      currentIndex = 0;
    });
  });
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', initMosaicHover);

// Re-initialize when new products are loaded (for infinite scroll)
if (window.MutationObserver) {
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        initMosaicHover();
      }
    });
  });
  
  document.addEventListener('DOMContentLoaded', function() {
    const productGrid = document.querySelector('#product-grid, .collection-product-list');
    if (productGrid) {
      observer.observe(productGrid, { childList: true });
    }
  });
}
